import * as React from 'react';

import {useHistory} from 'react-router-dom';

import {TesAuthorCredits} from '@app/components/UI/VetTesCard/VetTesCard';
import {dateConvert} from '@app/components/Pages/PetMemorial/utils/dateConvert';
import {DatePost, PetMemorialCardProps} from '@app/objects/PetMemorial';

import imagePlaceholder from '@app/images/image-placeholder.png';
import {bodyOverflowTransform} from '@app/components/LocalCommon/Utils/bodyOverflowTransform';
import {getImagePath} from '@app/objects/Image';

const PetMemorialCard: React.FC<PetMemorialCardProps> = ({memorial, setModalVisible}) => {

	const history = useHistory();
	const openModal = (e) => {
		e.preventDefault();
		bodyOverflowTransform(true);
		setModalVisible(true);
		history.push(`/pet-memorial/${memorial.id}`);
	};

	const [memorialDates, setMemorialDates] = React.useState<{
		dateBirth: string | null,
		datePass: string | null,
		datePost: DatePost
	}>();

	const avatarHeight = 100;
	const avatarWidth = 100;

	React.useEffect(() => {
		setMemorialDates(dateConvert(memorial));
	}, [memorial]);

	const [imgSrc, setImgSrc] = React.useState(memorial.images[0]);

	React.useEffect(() => {
		setImgSrc(memorial.images[0]);
	}, []);

	return(
		<a
			key = {memorial.id}
			className="pet-memorial-body__content-card"
			onClick ={openModal}
		>
			<header className="pet-memorial-body__content-card-header">
				<div className="pet-memorial-body__content-card-title">
					{
						imgSrc &&
							<div className="pet-memorial-body__content-card-title-img-wrap">
								<img
									className={imgSrc === imagePlaceholder ? 'placeholder' : 'photo'}
									src={imgSrc !== imagePlaceholder ? getImagePath(imgSrc, avatarHeight, avatarWidth) : imgSrc}
									onError={() => setImgSrc(imagePlaceholder)}
									alt = {`Lap of Love Veterinary Hospice ${memorial.city ? memorial.city : ''}, ${memorial.state ? memorial.state : ''} ${memorial.petName ? `${memorial.petName}'s memorial ${memorial.firstName ? `by ${memorial.firstName} ${memorial.lastName}` : ''}` : ''}`}
								/>
							</div>
					}
					<h4>
						{memorial.petName}
					</h4>
				</div>
				{memorialDates && (memorialDates.dateBirth || memorialDates.datePass) &&
				<div className="pet-memorial-body__content-card-lifetime">
					{memorialDates.dateBirth &&
					<>
						<span>{memorialDates.dateBirth}</span>
						<span> - </span>
					</>
					}
					<span>{memorialDates.datePass || '...'}</span>
				</div>
				}
			</header>
			<div className="pet-memorial-body__content-card-text">
				<p>
					{memorial.message}
				</p>
			</div>
			<TesAuthorCredits
				firstName={memorial.firstName}
				lastName={memorial.lastName}
				city={memorial.city}
				state={memorial.state}
				date={dateConvert(memorial).datePost}
			/>
		</a>
	);
};

export default PetMemorialCard;